import { render, staticRenderFns } from "./Counter.vue?vue&type=template&id=e157dad6&scoped=true&"
import script from "./Counter.vue?vue&type=script&lang=ts&"
export * from "./Counter.vue?vue&type=script&lang=ts&"
import style0 from "./Counter.vue?vue&type=style&index=0&id=e157dad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e157dad6",
  null
  
)

export default component.exports